/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SchedulingDayDetails {
    getFixupPrototypeFunction() { return SchedulingDayDetails.fixupPrototype; }

    static newInstance(model: Partial<SchedulingDayDetails>): SchedulingDayDetails {
        let obj = Object.assign(new SchedulingDayDetails(), model);
        SchedulingDayDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SchedulingDayDetails>): SchedulingDayDetails {
        if (!model) return null;
        return SchedulingDayDetails.newInstance(<SchedulingDayDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SchedulingDayDetails) {
        if (!obj) return;

        models.SchedulingDayDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SchedulingDayDetails): boolean {
        Object.setPrototypeOf(obj, SchedulingDayDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * At which day of that month or week the given category is scheduled to run.Allowed values: 1-31, for month and 0-7 or SUN-SAT for week. Both 0 and 7 represent Sunday.
     */
    day: string;

}
